import React, { useState } from "react";
import { useAuth } from "../../utility/auth";
import {
  Container,
  Grid,
  useTheme,
  Box,
  Stack,
  IconButton,
} from "@mui/material";
import Load from "../../components/FormsUI/Loader/index";
import Controls from "../../components/FormsUI";
import ContentController from "../../controller/ContentController";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import ImagePopup from "./ImagePopup";
import VideoPopup from "./VideoPopup";
import ArticlePopup from "./ArticlePopup";
import ExceptionHandlerController from "../../controller/ErrorLogsController";
import "../../css/style.css";
import { tokens } from "../../theme";

const ContentManage = () => {
  const theme = useTheme();
  const auth = useAuth();
  const user = auth.decoder(sessionStorage.getItem("user"));
  const { data, token } = user;
  const [alert, setAlert] = useState({ counter: 0, type: "", msg: "" });
  const [imagePopUp, setImagePopUp] = useState(false);
  const [videoPopUp, setVideoPopUp] = useState(false);
  const [isStateUpdate, setIsStateUpdate] = useState(false);
  const [updatedData, setUpdatedData] = useState({
    contentId: "",
    sectionId: "",
    subSectionId: "",
    description: "",
    sectionName: "",
    subSectionName: "",
    title: "",
    dateOfEvent: "",
    place: "",
    details: "",
    noOfLionPresent: "",
    amount: "",
    dataSource: "",
    positionName: "",
    memberId: "",
    memberName: "",
    memberEmail: "",
    positionNo: "",
    contentBody: "",
    memberContactNo: "",
    keyword: "",
    activityType: "",
    coverImageIndex: null,
    image: [],
    beneficiary: "",
  });
  const [numberMinMax, setNumberMinMax] = useState({
    noOfLionPresent: updatedData?.noOfLionPresent ?? "",
    amount: updatedData?.amount ?? "",
    memberContactNo: updatedData?.memberContactNo ?? "",
    beneficiary: updatedData?.beneficiary ?? "",
  });
  const [activeButton, setActiveButton] = useState("article");
  const [articlePopUp, setArticlePopUp] = useState(true);
  const [sectionGrid, setSectionGrid] = useState([]);
  const [loader, setLoader] = useState(true);
  const contentController = new ContentController();
  const exceptionHandlerController = new ExceptionHandlerController();
  // const { userid: tenantId } = data.UserInfo;
  const { userid: userId, tenantid: tenantId } = data.UserInfo;
  const colors = tokens(theme.palette.mode);
  const [popup, setPopUp] = useState(false);
  const [popup1, setPopUp1] = useState(false);
  const showAlert = (type, msg) => {
    const notify = { ...alert };
    notify.counter = notify.counter + 1;
    notify.type = type;
    notify.msg = msg;
    setAlert(notify);
  };

  React.useEffect(() => {
    getSectionsGrid();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const columns = [
    { headerName: "Id", field: "contentId", hide: true, filterable: false },
    { headerName: "Section", field: "sectionName", width: 180 },
    { headerName: "Sub Section", field: "subSectionName", width: 300 },
    { headerName: "Title", field: "title", width: 200 },
    { headerName: "Create Date", field: "createdDate", width: 130 },
    {
      field: "action",
      headerName: "Action",
      width: 180,
      sortable: false,
      disableExport: true,
      filterable: false,
      disableClickEventBubbling: true,
      renderCell: (params) => {
        const onClick = async (e, type) => {
          try {
            setAlert({ counter: 0, type: "", msg: "" });
            const currentRow = params.row;

            if (type === "Edit") {
              await handleEdit(currentRow);
            } else {
              await handleDelete(currentRow);
            }
          } catch (error) {
            handleError(error);
          }
        };

        const handleEdit = async (currentRow) => {
          setIsStateUpdate(false);
          resetFormFields();

          const resultObj = await contentController.GetContentId(
            currentRow.id,
            token
          );

          if (resultObj.status === 200) {
            updateData(resultObj.data.body);
            setIsStateUpdate(true);
            updateNumberMinMax(resultObj.data.body);
          } else {
            showAlert("error", resultObj?.response?.data?.message);
          }

          handleData();
          handleClick({ type: "article" });
        };

        const handleDelete = async (currentRow) => {
          const resultObj = await contentController.Delete(
            currentRow.id,
            token
          );

          if (resultObj.status === 200) {
            showAlert("success", "Deleted successfully");
            getSectionsGrid();
          } else {
            showAlert("error", resultObj?.response?.data?.message);
          }
        };

        const resetFormFields = () => {
          setNumberMinMax({
            noOfLionPresent: "",
            amount: "",
            memberContactNo: "",
            beneficiary: "",
          });
          setUpdatedData({});
        };

        const updateData = (response) => {
          setUpdatedData((prev) => ({
            ...prev,
            contentId: response?._id,
            tenantId: response?.tenantId ?? "",
            sectionId: response?.sectionId ?? "",
            subSectionId: response?.subSectionId ?? "",
            description: response?.description ?? "",
            sectionName: response?.sectionName ?? "",
            subSectionName: response?.subSectionName ?? "",
            title: response?.title ?? "",
            dateOfEvent: response?.dateOfEvent ?? "",
            place: response?.place ?? "",
            details: response?.details ?? "",
            dataSource: response?.dataSource ?? "",
            positionName: response?.positionName ?? "",
            memberId: response?.memberId ?? "",
            memberName: response?.memberName ?? "",
            memberEmail: response?.memberEmail ?? "",
            positionNo: response?.positionNo ?? "",
            contentBody: response?.contentBody ?? "",
            keyword: response?.keyword ?? "",
            image: response?.image ?? [],
            activityType: response?.activityType ?? "",
            coverImageIndex: response?.coverImageIndex ?? null,
          }));
        };

        const updateNumberMinMax = (response) => {
          setNumberMinMax((prev) => ({
            ...prev,
            noOfLionPresent: response?.noOfLionPresent,
            amount: response?.amount,
            memberContactNo: response?.memberContactNo,
            beneficiary: response?.beneficiary,
          }));
        };

        const handleError = (error) => {
          const logData = {
            message: error?.message,
            stack: error?.stack,
          };
          const logError = {
            logData,
            module: "service page onClick(Edit) method",
          };
          exceptionHandlerController.HandleException(logError);
        };

        return (
          <Stack direction="row" spacing={1}>
            <>
              <IconButton>
                <EditIcon
                  type="button"
                  color="primary"
                  id="Edit"
                  onClick={(e) => onClick(e, "Edit")}
                />
              </IconButton>
              <IconButton>
                <DeleteIcon
                  type="button"
                  color="primary"
                  id="Delete"
                  onClick={(e) => onClick(e, "Delete")}
                />
              </IconButton>
            </>
          </Stack>
        );
      },
    },
  ];

  const handlePopup = (value) => setPopUp(value);
  const handleData = () => setPopUp(true);
  const handlePopup1 = (value) => setPopUp1(value);
  const handleData1 = () => setPopUp1(true);
  //About,Contact us is not configured here so remove from dropdown section

  const getSectionsGrid = () => {
    let caughtError;
    try {
      contentController
        .GetGridData(tenantId, token)
        .then((resultObj) => {
          setLoader(() => false);
          if (resultObj.status === 200) {
            const userData = resultObj?.data?.body?.map((item) => {
              const { contentId: id, ...rest } = item;
              return { id, ...rest };
            });
            setSectionGrid(() => userData);
          } else {
            showAlert("error", resultObj?.response?.data?.message);
          }
        })
        .catch((error) => {
          caughtError = error;
          let logData = {};
          logData.message = caughtError?.message;
          logData.stack = caughtError?.stack;
          let logError = { logData, module: "contentManage.jsx page inside getServiceGrid method" };
          exceptionHandlerController.HandleException(logError);
        });
    } catch (error) {
      caughtError = error;
      let logData = {};
      logData.message = caughtError?.message;
      logData.stack = caughtError?.stack;
      let logError = { logData, module: "sercontentManage.jsx page getServiceGrid method" };
      exceptionHandlerController.HandleException(logError);
    }
  };

  const AddContent = (e) => {
    setUpdatedData({});
    setNumberMinMax({});
    handleClick({ type: "article" });
    handleData1();
  };

  const handleClick = (dataType) => {
    setImagePopUp(false);
    setArticlePopUp(false);
    setVideoPopUp(false);
    setActiveButton(dataType?.type);
    setTimeout(() => {
      if (dataType?.type === "images") {
        setImagePopUp(true);
      } else if (dataType?.type === "article") {
        setArticlePopUp(true);
      } else if (dataType?.type === "videos") {
        setVideoPopUp(true);
      }
    }, 50);
  };

  if (loader) return <Load />;
  return (
    <Box
      sx={{
        "& .formBg": {
          border: `1px solid ${colors.grey[900]}`,
          background: `${colors.primary[400]}`,
        },
        "& li.MuiBreadcrumbs-li h6": { color: `${colors.primary[200]}` },
        "& .MuiGrid-root.Mui-heading h2": {
          color: `${colors.primary[200]} !important`,
        },
      }}
    >
      <Grid container>
        <Grid className="breadcrumb-section">
          <Grid className="breadcrumb-container">
            <Grid className="Mui-li">
              <nav className="Mui-nav" aria-label="breadcrumb">
                <ol className="">
                  <li className="MuiBreadcrumbs-li">
                    <h6 className="breadsub">Home</h6>
                  </li>
                  <li aria-hidden="true" className="MuiBreadcrumbs-separator">
                    /
                  </li>
                  <li className="MuiBreadcrumbs-li">
                    <h6>Content</h6>
                  </li>
                </ol>
              </nav>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} md={12} className="adduser au1 pt-2">
          <Controls.ActionButton onClick={AddContent}>
            Add Contents
          </Controls.ActionButton>
        </Grid>
        <Grid item xs={12} className="formBg">
          <Container maxWidth="md" className="formClwidth">
            <div>
              <Controls.Grid
                columns={columns}
                data={sectionGrid}
                fileName={"Edit Content"}
              />
              {popup && isStateUpdate && (
                <Controls.Popup
                  title="Edit Content"
                  openPopup={popup}
                  setOpenPopup={handlePopup}
                >
                  <Grid item xs={12} className="contentButton">
                    <Controls.ActionButton
                      className={activeButton === "article" ? "active" : ""}
                      onClick={() => handleClick({ type: "article" })}
                    >
                      Article
                    </Controls.ActionButton>
                    <Controls.ActionButton
                      className={activeButton === "images" ? "active" : ""}
                      onClick={() => handleClick({ type: "images" })}
                    >
                      Images
                    </Controls.ActionButton>
                    <Controls.ActionButton
                      className={activeButton === "videos" ? "active" : ""}
                      onClick={() => handleClick({ type: "videos" })}
                    >
                      Videos
                    </Controls.ActionButton>
                  </Grid>
                  <div className="content-popup">
                    {imagePopUp && (
                      <ImagePopup
                        getSectionsGrid={getSectionsGrid}
                        updatedData={updatedData}
                        handlePopup1={handlePopup1}
                        setUpdatedData={setUpdatedData}
                        numberMinMax={numberMinMax}
                        setNumberMinMax={setNumberMinMax}
                      />
                    )}
                    {articlePopUp && (
                      <ArticlePopup
                        getSectionsGrid={getSectionsGrid}
                        updatedData={updatedData}
                        handlePopup1={handlePopup1}
                        setUpdatedData={setUpdatedData}
                        numberMinMax={numberMinMax}
                        setNumberMinMax={setNumberMinMax}
                      />
                    )}
                    {videoPopUp && (
                      <VideoPopup
                        getSectionsGrid={getSectionsGrid}
                        updatedData={updatedData}
                        handlePopup1={handlePopup1}
                        setUpdatedData={setUpdatedData}
                        numberMinMax={numberMinMax}
                        setNumberMinMax={setNumberMinMax}
                      />
                    )}
                  </div>
                </Controls.Popup>
              )}

              {popup1 && (
                <Controls.Popup
                  title="Add Content"
                  minHeight={100}
                  openPopup={popup1}
                  setOpenPopup={handlePopup1}
                >
                  <Grid item xs={12}>
                    <Grid item xs={12} className="contentButton">
                      <Controls.ActionButton
                        onClick={() => handleClick({ type: "article" })}
                        className={activeButton === "article" ? "active" : ""}
                      >
                        Article
                      </Controls.ActionButton>
                      {updatedData?.contentId && (
                        <>
                          <Controls.ActionButton
                            onClick={() => handleClick({ type: "images" })}
                            className={
                              activeButton === "images" ? "active" : ""
                            }
                          >
                            Images
                          </Controls.ActionButton>
                          <Controls.ActionButton
                            onClick={() => handleClick({ type: "videos" })}
                            className={
                              activeButton === "videos" ? "active" : ""
                            }
                          >
                            Videos
                          </Controls.ActionButton>
                        </>
                      )}
                    </Grid>
                    <div className="content-popup">
                      {imagePopUp && (
                        <ImagePopup
                          handlePopup1={handlePopup1}
                          getSectionsGrid={getSectionsGrid}
                          updatedData={updatedData}
                          setUpdatedData={setUpdatedData}
                          numberMinMax={numberMinMax}
                          setNumberMinMax={setNumberMinMax}
                        />
                      )}
                      {articlePopUp && (
                        <ArticlePopup
                          handlePopup1={handlePopup1}
                          getSectionsGrid={getSectionsGrid}
                          updatedData={updatedData}
                          setUpdatedData={setUpdatedData}
                          numberMinMax={numberMinMax}
                          setNumberMinMax={setNumberMinMax}
                          activeButton={activeButton}
                          setActiveButton={setActiveButton}
                        />
                      )}

                      {videoPopUp && (
                        <VideoPopup
                          handlePopup1={handlePopup1}
                          getSectionsGrid={getSectionsGrid}
                          updatedData={updatedData}
                          setUpdatedData={setUpdatedData}
                          numberMinMax={numberMinMax}
                          setNumberMinMax={setNumberMinMax}
                        />
                      )}
                    </div>
                  </Grid>
                </Controls.Popup>
              )}
            </div>
          </Container>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ContentManage;
